import { DollarSign, TrendingUp, Users, Calendar } from 'lucide-react';
import { formatCurrencyNoDecimals } from '@/utils/formatters';
import type { Fund } from '@/types';

interface FundSummaryCardsProps {
  fund: Fund;
  investorCount: number;
  totalCommitments: number;
}

export function FundSummaryCards({
  fund,
  investorCount,
  totalCommitments,
}: FundSummaryCardsProps) {
  const items = [
    {
      icon: DollarSign,
      label: 'Commitment',
      value: formatCurrencyNoDecimals(totalCommitments, fund.base_currency),
    },
    {
      icon: TrendingUp,
      label: 'Target Size',
      value: fund.target_size
        ? formatCurrencyNoDecimals(fund.target_size, fund.base_currency)
        : 'N/A',
    },
    {
      icon: Users,
      label: 'Investors',
      value: investorCount.toString(),
    },
    {
      icon: Calendar,
      label: 'Fund Term',
      value: fund.fund_term_years ? `${fund.fund_term_years} years` : 'N/A',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:flex sm:items-center sm:gap-8 py-2">
      {items.map((item, index) => (
        <div key={item.label} className="flex items-center gap-8">
          <div className="flex items-center gap-3">
            <item.icon className="h-4 w-4 text-muted-foreground flex-shrink-0" />
            <div className="flex flex-col min-w-0">
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                {item.label}
              </span>
              <span className="text-lg font-semibold text-foreground truncate">
                {item.value}
              </span>
            </div>
          </div>
          {index < items.length - 1 && (
            <div className="hidden sm:block h-8 w-px bg-border flex-shrink-0" />
          )}
        </div>
      ))}
    </div>
  );
}
